import gql from "graphql-tag";

export const updateDealerIncentiveMutation = gql`
  mutation updateDealerIncentive(
    $id: ID!
    $name: String
    $description: String
    $startsAt: Timestamp
    $endsAt: Timestamp
    $measurementUnit: DealerIncentiveMeasurementUnit
    $targetValue: Float
    $reward: String
    $color: String
    $typeId: ID
    $files: SyncAssociations
  ) {
    updateDealerIncentive(
      id: $id
      name: $name
      description: $description
      startsAt: $startsAt
      endsAt: $endsAt
      measurementUnit: $measurementUnit
      targetValue: $targetValue
      reward: $reward
      color: $color
      typeId: $typeId
      files: $files
    ) {
      id
    }
  }
`;

export const deleteDealerIncentiveMutation = gql`
  mutation deleteDealerIncentive($id: ID!) {
    deleteDealerIncentive(id: $id) {
      id
    }
  }
`;

export const endDealerIncentiveEarlyMutation = gql`
  mutation endDealerIncentiveEarly($id: ID!) {
    endDealerIncentiveEarly(id: $id) {
      id
      status
      completedEarlyAt
    }
  }
`;
